<template>
  <div>
    <BRow v-if="token && apiKey">
      <BCol cols="12">
        <BCard>
          <h5>
            Token : {{ token }}
          </h5>
          <h5>
            Api key : {{ apiKey }}
          </h5>
          <RouterLink :to="{name: 'mobile-for-you'}">
            Sana Özel Kullanıcılar
          </RouterLink>
        </BCard>
      </BCol>
    </BRow>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { locales } from '@/libs/i18n/all-locales'
import { localeChanged, localize } from 'vee-validate'
import { BCard, BCol, BRow } from 'bootstrap-vue'

const envApiKey = process.env.VUE_APP_API_KEY
const userToken = useJwt.getToken()

export default {
  name: 'MobileTools',
  components: {
    BCard, BCol, BRow,
  },
  computed: {
    apiKey() {
      const apiKey = this.$cookies.get('api-key') || envApiKey
      if (apiKey) {
        // Önceki api key'i temizle
        useJwt.setApiKey(apiKey)

        this.$cookies.set('api-key', apiKey)
      }
      return apiKey
    },
    token() {
      const token = this.$cookies.get('token') || userToken
      if (token) {
        // Önceki token'ı temizle
        useJwt.setToken(token)

        this.$cookies.set('token', token)
      }
      return token
    },
  },
  created() {
    const locale = this.$cookies.get('locale')

    // Cookie'den dil geldiyse o dili ayarla
    if (locale) {
      const selectedLocale = locales.find(l => l.locale === locale)

      if (selectedLocale) {
        this.updateLocale(locale)
      }
    }
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale
      localize(locale)
      localeChanged()
      localStorage.setItem('locale', locale)

      if (locale === 'ar') {
        localStorage.setItem('isRTL', 'on')
      }
      this.$store.commit('appConfig/TOGGLE_RTL', locale === 'ar')

      this.updateLocaleFromServer(locale)
    },
    updateLocaleFromServer(lang) {
      if (lang) {
        useJwt.updateLanguage(lang)
      }
    },
  },
}
</script>
